import React from 'react';

const DealsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default DealsPage;
